import {FC} from "react"
import "./App.css";
import "animate.css";
import ToasterProvider from "./Providers/ToasterProvider";

import MainRoutes from "./routes/MainRoutes";

type AppProps = {};
//  ***************************   Polyfills of  groupBy method of array  ****************************  ///
type FuncType = (param: any) => any;

declare global {
  interface Array<T> {
    customGroupBy<T>(keyFinder: T | keyof T | FuncType): any;
  }
}
// ****************************  Some hidden talents of our  mighty & lovely Javascript ************** ///
Array.prototype.customGroupBy = function <T>(keyFinder: keyof T | FuncType) {
  return (this as Array<T>).reduce((acc: any, curr: T) => {
    const key =
      typeof keyFinder === "function"
        ? keyFinder(curr)
        : !!curr && typeof curr === "object"
        ? curr[keyFinder]
        : curr;
    acc[key] = !acc?.[key] ? [curr] : [...acc[key], curr];
    return acc;
  }, {});
};

const App: FC<AppProps> = (): JSX.Element => {
  return (
    // <CombinedContext>
    <>
      <ToasterProvider />
      <MainRoutes />
    </>
    // </CombinedContext>
  );
};

export default App;
